<template>
  <div>
      <ax-step v-for="(item,index) in recordList" :key="index" :data="item" :comment="index===1?commentsList:[]"></ax-step>
  </div>
</template>
<script>
export default {
  data(){
    return {
		commentsList: [],
        recordList: []
    }
  }
}
</script>
<style lang="scss" scoped>

</style>